





















import { Component, Vue } from 'vue-property-decorator';
import MainLayout from '@/layouts/Main.vue';
import AuthService from '@/services/auth';
import { Lang } from '@/lang/en/logout.ts';
import { $router } from '@/main';

@Component({
  components: {
    MainLayout,
  },
})
export default class Dashboard extends Vue {
  private lang: object = Lang;

  private cancelLogout = () => {
    $router.push({
      name: this.$store.state.route.from.name,
    });
  }
  private doLogout = () => {
    AuthService.Logout();
  }
}
